<template>
  <div>
    <h4 class="mb-1">Подозрительная активность</h4>
    <b-alert v-if="errorText" show variant="danger">{{ errorText }}</b-alert>
    <b-table :items="rows" :fields="fields" :busy="loading" striped responsive empty-text="Событий нет" />
  </div>
</template>

<script>
import { BAlert, BTable } from 'bootstrap-vue'
import identityApi from '@/services/identity-api.service'

export default {
  name: 'SecurityEventsPage',
  components: { BAlert, BTable },
  data() {
    return {
      loading: false,
      errorText: '',
      rows: [],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'type', label: 'Тип' },
        { key: 'userId', label: 'Пользователь' },
        { key: 'count', label: 'Счётчик' },
        { key: 'payload', label: 'Детали', formatter: v => (v ? JSON.stringify(v) : '—') },
        { key: 'createdAt', label: 'Когда' },
      ],
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.loading = true
      try {
        const { data } = await identityApi.getSecurityEvents({ maxResultCount: 100 })
        this.rows = data.rows || data || []
      } catch (e) {
        this.errorText = e.response?.data?.message || 'Не удалось загрузить события'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
